<template>
  <row class="payments-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="payment in payments" :key="payment.id">
      <payments-item
        :payment="payment"
        @open-payment="openPayment"
        :all="all"
      />
    </i-col>
  </row>
</template>

<script>
import PaymentsItem from './payments-item'

export default {
  components: {
    PaymentsItem
  },
  props: ['payments', 'all'],
  methods: {
    openPayment (payload) {
      this.$emit('open-payment', payload)
    }
  }
}
</script>

<style>
</style>
